export default __webpack_public_path__ + "static/media/menu-icon.a425255c.svg";